import Main from "../../../assets/images/projects/about/Main.png";

import { ProjectDetailProps } from "../props";

export default {
  title: "Hello there!",
  timeline: "",
  context: "",
  team: [],
  thumbnail: Main,
  contents: [
    {
      left: {
        title: "",
        content: (
          <div>
            <p>
              My full name is Freddy Albert Sanjaya, but you can call me
              Freddy.
            </p>
            <p>
              I am a Visual Communication Design graduate who has worked across
              product visuals, campaigns, checkout, and promotion experiences
              at Blibli and Traveloka. I care about turning messy questions into
              thoughtful experiences that are useful to people.
            </p>
            <p>
              Today, I am making more room for design, writing, and work that
              feels worth caring about. I am curious about human behaviour,
              systems, and the small choices that shape how something feels.
            </p>
            <p>
              Earlier in my journey, I supported Inspiration Factory Foundation,
              a children’s education nonprofit. That experience stayed with me:
              good creative work can be practical, generous, and socially
              meaningful at the same time.
            </p>
          </div>
        ),
      },
      right: {
        title: "",
        content: (
          <div>
            <p>
              Outside work, I play guitar, sing, read, write, and occasionally
              make illustrations for no reason other than enjoying the process.
              I spend a lot of time reflecting on life and noticing how people
              make sense of it differently.
            </p>
            <p>
              I am interested in personal growth and social impact—not as big
              slogans, but as everyday choices. I believe everyone can keep
              learning and offer something useful to the people around them.
            </p>
            <p>
              I enjoy meeting people with different stories and ways of seeing
              the world. If you would like to <b>collaborate</b>, exchange
              ideas, or <b>invite me to a session</b>, feel free to write to{" "}
              <a
                style={{
                  marginLeft: "4px",
                  marginRight: "4px",
                  color: "black",
                }}
                href="mailto:freddy11sanjaya@gmail.com"
              >
                freddy11sanjaya@gmail.com
              </a>
              or send me a message on Instagram{" "}
              <a
                style={{ color: "black" }}
                href="https://www.instagram.com/freddy_as/"
                target="_blank"
                rel="noreferrer noopener"
              >
                @freddy_as
              </a>
              .
            </p>
          </div>
        ),
      },
      bottomImage: "",
    },
  ],
} as ProjectDetailProps;
